import ShoppingBagIcon from '@mui/icons-material/ShoppingBag'
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const RetailIcon = (props: SvgIconProps) => {
  return <ShoppingBagIcon {...props} data-testid="RetailIcon" />
}
